export const createVoucherModel = ({ ticketsIds }) => ({
  tickets_ids: ticketsIds
})

export const cancelVoucherModel = ({ ticketsIds }) => ({
  tickets_ids: ticketsIds
})
